import axios from "@/axios.js";
import cl from "../../http/requests/claims/index.js";
import hr from "../../http/requests/hrms/index.js";
import photoUpload from "../../http/requests/photo/index.js";
export default {
  addClaims({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/claims", item)
        .then((response) => {
          commit("ADD_CLAIMS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateClaims({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/claims", item)
        .then((response) => {
          commit("UPDATE_CLAIMS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addClaimsDetails({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/claimsdetails", item)
        .then((response) => {
          //console.log("addClaimsDetails")

          commit("ADD_CLAIMSDETAILS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateClaimsDetails({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put("/api/claims/details", item)
        .then((response) => {
          //console.log("updateClaimsDetails")

          commit("UPDATE_CLAIMSDETAILS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteClaimsDetails({ commit }, claimsDetailsId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/claims/details/${claimsDetailsId}`)
        .then((response) => {
          commit("DELETE_CLAIMSDETAILS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getClaimsDetailsByClaimsId({ commit }, claimsId) {
    return new Promise((resolve, reject) => {
      cl.getClaimsDetailsByClaimsId(claimsId)
        .then((response) => {
          commit("GET_CLAIMSDETAILS_BY_CLAIMSID", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAllEmployeeClaims({ commit }, payload) {
    return new Promise((resolve, reject) => {
      cl.getAllClaims(
        payload.sortBy,
        payload.sortOrder,
        payload.pageNumber,
        payload.pageSize,
        payload.isApprover
      )
        .then((response) => {
          commit("GET_ALL_CLAIMS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getAllApproversByModule({ commit }, item) {
    return new Promise((resolve, reject) => {
      hr.getAllApproversByModule(item.module, item.userId)
        .then((response) => {
          commit("GET_ALL_APPROVERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  unSubmit({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isSubmitted: items.isSubmitted,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("UNSUBMIT_CLAIMS", items.employeeFiledClaimsId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onCancelled({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isSubmitted: items.isSubmitted,
          isCancelled: items.isCancelled,
          cancelledOn: items.cancelledOn,
          isReviewerRevised: items.isReviewerRevised,
          isApproverRevised: items.isApproverRevised,
          remarks: items.remarks,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("CANCELLED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onRetracked({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isDraft: items.isDraft,
          isRetracted: items.isRetracted,
          retractedOn: items.retractedOn,
          isReviewerApproved: items.isReviewerApproved,
          isApproverApproved: items.isApproverApproved,
          remarks: items.remarks,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("RETRACKED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onReviewed({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isReviewerUnread: items.isReviewerUnread,
          isReviewerApproved: items.isReviewerApproved,
          reviewerApprovedOn: items.reviewerApprovedOn,
          isRetracted: items.isRetracted,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("REVIEWED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onReviewerDenied({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isReviewerUnread: items.isReviewerUnread,
          isReviewerDenied: items.isReviewerDenied,
          reviewerDeniedOn: items.reviewerDeniedOn,
          isRetracted: items.isRetracted,
          reviewerComments: items.reviewerComments,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("REVIEWERDENIED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onReviewerRevised({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isReviewerUnread: items.isReviewerUnread,
          isReviewerRevised: items.isReviewerRevised,
          reviewerForRevisionOn: items.reviewerForRevisionOn,
          isRetracted: items.isRetracted,
          reviewerComments: items.reviewerComments,
          reviewerId: items.reviewerId,
        })
        .then((response) => {
          commit("REVIEWERREVISED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onApproved({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isApproverUnread: items.isApproverUnread,
          isApproverApproved: items.isApproverApproved,
          approverApprovedOn: items.approverApprovedOn,
          isApproverRetracked: items.isApproverRetracked,
          approverId: items.approverId,
        })
        .then((response) => {
          commit("APPROVED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onApproverDenied({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isApproverUnread: items.isApproverUnread,
          isApproverDenied: items.isApproverDenied,
          approverDeniedOn: items.approverDeniedOn,
          isApproverRetracked: items.isApproverRetracked,
          approverComments: items.approverComments,
          approverId: items.approverId,
        })
        .then((response) => {
          commit("APPROVERDENIED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  onApproverRevised({ commit }, items) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/claims/${items.employeeFiledClaimsId}`, {
          action: items.action,
          isApproverUnread: items.isApproverUnread,
          isApproverRevised: items.isApproverRevised,
          approverForRevisionOn: items.approverForRevisionOn,
          isApproverRetracked: items.isApproverRetracked,
          approverComments: items.approverComments,
          approverId: items.approverId,
        })
        .then((response) => {
          commit("APPROVERREVISED_CLAIMS", items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
